import { render, staticRenderFns } from "./ChipGroup.vue?vue&type=template&id=0e4dc966&scoped=true&"
import script from "./ChipGroup.vue?vue&type=script&lang=ts&"
export * from "./ChipGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ChipGroup.vue?vue&type=style&index=0&id=0e4dc966&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4dc966",
  null
  
)

export default component.exports